module.exports = __webpack_public_path__ + "selwebee_spt_candyjar-SPANISH-bfa4795c143452bc3306e3bf0654ddce.png";